<template>
  <div>
    <Navbar :name="navbarName"/>
    <div class="container">
      <keep-alive>
        <thematicsCarousel :thematics="this.thematics" />
      </keep-alive>
      <div class="row">
        <div class="col-12 col-lg-4">
          <ValidThematicSelection :thematics="thematics"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ThematicsCarousel from "../carousels/ThematicsCarousel";
import ValidThematicSelection from "../ui/buttons/ValidThematicSelection";
import Navbar from "../ui/Navbar";

export default {
	name: "ThematicSelectionView",
	components: {
		ThematicsCarousel,
		Navbar,
		ValidThematicSelection,
	},
	data() {
		return {
			thematics: process.env.VUE_APP_THEMATICS,
			textStyle: {
				"color": process.env.VUE_APP_PRIMARY_COLOR,
				"marginTop": "3rem",
				"marginBottom": "20px",
			},
			navbarName: "Création d'une nouvelle vidéo",
		};
	},
	beforeDestroy() {
		if (sessionStorage.getItem("destinationLang") && sessionStorage.getItem("origin_lang")) {
			sessionStorage.removeItem("destinationLang");
			sessionStorage.removeItem("origin_lang");
		}
	},
};
</script>

<style scoped>

</style>
